import { useEffect, useState } from "react";
import i18n from "@/i18n";
import en from "date-fns/locale/en-GB";
import es from "date-fns/locale/es";

export const localeMap = {
  en,
  es,
};

const useDatePickerLocale = () => {
  const [locale, setLocale] = useState(en);

  useEffect(() => {
    setLocale(localeMap[i18n.language] ?? en);
  }, [i18n.language]);

  return locale;
};

export default useDatePickerLocale;
